
  const ruleVaccination = {
    path: "/ruleVaccination",
    name: "ruleVaccination",
    component: () => import(/* webpackChunkName: "rule_vaccination" */ "@/components/ruleVaccination/RuleVaccinationIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "rule_vaccination" */ "@/components/ruleVaccination/RuleVaccinationView.vue"), name: "ruleVaccinationView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "rule_vaccination" */ "@/components/ruleVaccination/RuleVaccinationEdit.vue"), name: "ruleVaccinationEdit" },
      { path: "create/:requirementId", component: () => import(/* webpackChunkName: "rule_vaccination" */ "@/components/ruleVaccination/RuleVaccinationCreate.vue"), name: "ruleVaccinationCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default ruleVaccination;
    